import type { BroadcastLayout, BroadcastWidget } from "../../lib/broadcastApi";
import { DEFAULT_OPTIONS } from "./editorMath";

export type TemplateId = "pitch_stats_sidebar" | "lower_third_stats";

const w = (
  id: string,
  type: BroadcastWidget["type"],
  x: number,
  y: number,
  width: number,
  height: number,
  z: number,
  options: Record<string, unknown> = DEFAULT_OPTIONS[type],
): BroadcastWidget => ({
  id,
  type,
  x,
  y,
  w: width,
  h: height,
  z,
  opacity: 1,
  text_scale: 1,
  visible: true,
  options: JSON.parse(JSON.stringify(options)),
});

/** Widgets of each starter template (all fit a 1920x1080 and 1920x1200 stage). */
export const TEMPLATES: Record<TemplateId, () => BroadcastWidget[]> = {
  pitch_stats_sidebar: () => [
    w("scoreboard-1", "scoreboard", 560, 24, 800, 110, 20),
    w("live-pitch-1", "live_pitch", 96, 272, 960, 656, 10),
    w("stats-panel-1", "stats_panel", 1128, 295, 696, 610, 12, {
      rows: ["possession", "shots", "shots-on-target", "corners", "fouls"],
    }),
    w("callouts-1", "callouts", 0, 0, 1920, 1080, 50),
  ],
  lower_third_stats: () => [
    w("scoreboard-1", "scoreboard", 96, 900, 800, 110, 20),
    w("stats-panel-1", "stats_panel", 920, 760, 904, 266, 12, {
      rows: ["possession", "shots", "shots-on-target"],
    }),
    w("callouts-1", "callouts", 0, 0, 1920, 1080, 50),
  ],
};

export const TEMPLATE_IDS = Object.keys(TEMPLATES) as TemplateId[];

/** Apply a template: replaces the widgets only, stage + call-outs stay. */
export function applyTemplate(layout: BroadcastLayout, id: TemplateId): void {
  layout.widgets = TEMPLATES[id]();
}
